import React, {Component} from 'react';
import {Link, withRouteData} from 'react-static';
import styled from 'styled-components';

const CountdownStyle = styled.div`
	margin-bottom: 6.25rem;
	
	h2 {
	    font-weight: 500;
	    font-size: 2.5rem;
	    line-height: 1.25em;
	}
	
	li {
		display: inline-block;
		font-size: 1.5rem;
		list-style-type: none;
		padding: 1rem;
		text-transform: uppercase;
	}
	
	li span {
		display: block;
		font-size: 3.5rem;
	    color: #83F5F8;
	    text-shadow: 0 0 4px rgba(131,245,248,0.50);
	}
	
	
`;

class Countdown extends Component {

	constructor(props) {
		super(props);

		this.state = {
			days: 0,
			hours: 0,
			minutes: 0,
			seconds: 0
		};

		this.dates = {
			presale: {
				start: +new Date('Nov 12, 2018 00:00:00'),
				end: +new Date('Dec 31, 2018 23:59:59'),
			},
			preico: {
				start: +new Date('Jan 1, 2019 00:00:00'),
				end: +new Date('Feb 28, 2019 23:59:59')
			},
			ico: {
				start: +new Date('Mar 1, 2019 00:00:00'),
				end: +new Date('May 31, 2019 23:59:59')
			},
			end: {
				start: +new Date('Jun 1, 2019 00:00:00')
			}
		};

		this.stages = {
			presale: this.props.cover.countdown.preSale,
			preico: this.props.cover.countdown.preICO,
			ico: this.props.cover.countdown.ico,
			end: this.props.cover.countdown.end
		};

		const dateNow = +new Date();

		if(this.dates.presale.start > dateNow) {
			this.currentStage = "pre";
			this.nextStage = "presale";
		} else if(this.dates.presale.start < dateNow && this.dates.presale.end > dateNow) {
			this.currentStage = "presale";
			this.nextStage = "preico";
		} else if(this.dates.preico.start < dateNow && this.dates.preico.end > dateNow) {
			this.currentStage = "preico";
			this.nextStage = "ico";
		} else if(this.dates.ico.start < dateNow && this.dates.ico.end > dateNow) {
			this.currentStage = "ico";
			this.nextStage = "end";
		} else {
			this.currentStage = "end";
			this.nextStage = "end";
		}

		this.timerID = null;

		this.zeroPadding = this.zeroPadding.bind(this);
		this.updateCountdown = this.updateCountdown.bind(this);
	}

	updateCountdown() {
		const current = +new Date();
		const distance = this.dates[this.nextStage].start - current;

		if(distance < 0) {
			return this.setState({
				days: 0,
				hours: 0,
				minutes: 0,
				seconds: 0
			});
		}

		this.setState({
			days: Math.floor(distance / 86400000),
			hours: Math.floor((distance % 86400000) / 3600000),
			minutes: Math.floor((distance % 3600000) / 60000),
			seconds: Math.floor((distance % 60000) / 1000)
		});

		this.timerID = setTimeout(this.updateCountdown, 1000);
	}

	zeroPadding(n) {
		return (n < 10 ? '0' : false) + n;
	}

	componentDidMount() {
		this.updateCountdown();
	}

	componentWillUnmount() {
		if(this.timerID) {
			clearInterval(this.timerID);
		}
	}

	render() {
		return (
			<CountdownStyle>
				<div className="container">
					<div className="row">
						<div className="columns small-12 medium-centered text-center">
							<div>
								{ this.currentStage !== "pre" && this.currentStage !== "ico" && this.currentStage !== "end" && <h2>{this.props.cover.countdown.current}: { this.stages[this.currentStage] }</h2> }
								{ this.currentStage === "ico" && <h2>{this.props.cover.countdown.icoRunning}</h2> }

								{ this.currentStage !== "end" && <h2>{this.props.cover.countdown.title} <span className="cyan">{ this.stages[this.nextStage] }</span></h2> }
								{ this.currentStage === "end" &&
									<div>
										<h2>{this.props.cover.countdown.over} </h2>
										<h2 className="cyan">{this.props.cover.countdown.announcement} </h2>
									</div>
								}

								<ul>
									<li><span id="days">{ this.zeroPadding(this.state.days) }</span>{ this.props.cover.countdown.days }</li>
									<li><span id="hours">{ this.zeroPadding(this.state.hours) }</span>{ this.props.cover.countdown.hours }</li>
									<li><span id="minutes">{ this.zeroPadding(this.state.minutes) }</span>{ this.props.cover.countdown.minutes }</li>
									<li><span id="seconds">{ this.zeroPadding(this.state.seconds) }</span>{ this.props.cover.countdown.seconds }</li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</CountdownStyle>
		)
	}
}

export default withRouteData(Countdown)


// WEBPACK FOOTER //
// /opt/build/repo/src/components/Countdown.js